import { BioTreatmentFacilityTalonList } from '../containers/BioTreatmentFacilityTalon';
import { accessTypeEnum } from '../lib/enum';
export default [{
  component: BioTreatmentFacilityTalonList,
  path: '/bioTreatmentFacilityTalon',
  access: [accessTypeEnum.admin, accessTypeEnum.adminBranch]
}];
